module.exports = __webpack_public_path__ + "img/icon-arrow-back.ae493307.svg";